import axios from "axios";
import { NewRepository, Repository } from "./repository";
const resource = "Serial";
const seriallRepo = {
    getProductInfo, registerService
};

function registerService(payLoad) {
    return Repository().post(`${resource}/register`, payLoad);
}

function getProductInfo(serialNo) {
    return Repository().get(`${resource}/GetProductInfo?serialNo=${serialNo}`);
}
export default seriallRepo;